module.exports = __webpack_public_path__ + "img/materials-search.3be86d07.svg";